import React from 'react';
import { HiOutlineExclamationTriangle } from 'react-icons/hi2';
import { chatCard, chatPrimary, chatSecondary } from './chat-theme';
import CardHeader from './card-header';
import { toolLabel } from '../model/copilot-state';

const target = args => {
    if (!args || typeof args !== 'object') return '';
    const id = args.workflow_id || args.tool_id || args.skill_id || args.server_id || args.codehook_id || args.source_id;
    return id ? String(id) : '';
};

/** A destructive action paused for the builder's decision (HITL interrupt in the copilot). */
export default function ApprovalCard({ requests, onApprove, onReject, disabled }) {
    if (!Array.isArray(requests) || !requests.length) return null;
    return (
        <div className={chatCard('decision')}>
            <CardHeader icon={HiOutlineExclamationTriangle} tone="decision" title="Approval needed" />
            <ul className="mb-4 space-y-1.5 text-[0.85rem] text-gray-700">
                {requests.filter(request => request && typeof request === 'object').map((request, index) => (
                    <li key={index} className="flex flex-wrap items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-2.5 py-1.5">
                        {toolLabel(request.tool)}
                        {target(request.args) && <code className="rounded-md bg-gray-100 px-1.5 py-0.5 font-mono text-xs text-gray-800 ring-1 ring-gray-200">{target(request.args)}</code>}
                    </li>
                ))}
            </ul>
            <div className="flex flex-wrap items-center gap-2">
                <button
                    type="button"
                    disabled={disabled}
                    onClick={onApprove}
                    className={chatPrimary}
                >
                    Approve
                </button>
                <button
                    type="button"
                    disabled={disabled}
                    onClick={() => onReject()}
                    className={chatSecondary}
                >
                    Reject
                </button>
                <p className="ml-auto text-xs text-gray-500">Or type a reply to reject with instructions.</p>
            </div>
        </div>
    );
}
